var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.276005 9.26345H2.00246V16.371C2.00246 16.5113 2.11616 16.625 2.25649 16.625H5.18376C5.32408 16.625 5.43779 16.5113 5.43779 16.371V9.29693H7.42249C7.55154 9.29693 7.66011 9.20009 7.67485 9.07191L7.97628 6.45528C7.98456 6.38328 7.96175 6.31119 7.91359 6.25718C7.86537 6.20312 7.79638 6.17218 7.72398 6.17218H5.43789V4.53195C5.43789 4.0375 5.70412 3.78677 6.22925 3.78677C6.30409 3.78677 7.72398 3.78677 7.72398 3.78677C7.8643 3.78677 7.97801 3.67301 7.97801 3.53274V1.13091C7.97801 0.990585 7.8643 0.87688 7.72398 0.87688H5.66403C5.6495 0.876169 5.61724 0.875 5.56968 0.875C5.21226 0.875 3.96989 0.945164 2.98851 1.84799C1.90115 2.84847 2.0523 4.04639 2.08842 4.25409V6.17213H0.276005C0.135677 6.17213 0.0219727 6.28584 0.0219727 6.42616V9.00937C0.0219727 9.14969 0.135677 9.26345 0.276005 9.26345Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7fb7d36ee5f71baab456f025ee4df518.svg";
export { ForwardRef as ReactComponent };